/**
 * DocumentTypeBadge Component
 *
 * Displays a badge in the toolbar area indicating the document type
 * (Master Copy or Control Copy). Regular documents show nothing.
 */

import React from 'react';
import type { DocumentType } from '@/types/editor.types';
import styles from './DocumentTypeBadge.module.css';

// =============================================================================
// TYPES
// =============================================================================

interface DocumentTypeBadgeProps {
  documentType: DocumentType | null;
}

// =============================================================================
// COMPONENT
// =============================================================================

export const DocumentTypeBadge: React.FC<DocumentTypeBadgeProps> = ({ documentType }) => {
  if (documentType === 'master') {
    return <span className={`${styles.badge} ${styles.master}`}>MASTER COPY</span>;
  }

  if (documentType === 'control') {
    return <span className={`${styles.badge} ${styles.control}`}>CONTROL COPY</span>;
  }

  return null;
};

export default DocumentTypeBadge;
